import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { FileData } from 'src/data-capture/hooks/file-uploads/types';

type UrlResponse = {
  url: string;
};

export const useFileTemporaryLinkMutation = () => {
  const {
    mutateAsync,
    isPending: isLoading,
    isError,
  } = useMutation<{ data: UrlResponse }, Error, FileData['id']>({
    mutationFn: fileId => api.post<UrlResponse>(`files/${fileId}/file-links`, {}),
  });

  const createLink = async (fileId: FileData['id']): Promise<UrlResponse> => {
    const result = await mutateAsync(fileId);
    return result.data;
  };

  return {
    createLink,
    isLoading,
    isError,
  };
};
